<template>
  <div class="w-full p-20px flex-1">
    <div class="text-23px font-bold text-black">发布新讨论</div>
    <el-form class="mt-30px mb-20px" ref="formRef" :model="form" :rules="formRule">
      <el-form-item label="标题" prop="title">
        <el-input v-model="form.title"></el-input>
      </el-form-item>
      <el-form-item label="内容" prop="content">
        <editor-vue height="300px" v-model="form.content" /> </el-form-item></el-form>
    <div class="flex items-center">
      <el-button type="primary" @click="release" :loading="loading">发布</el-button>
      <el-button @click="cancel">取消</el-button>
    </div>
  </div>
</template>

<script>
import EditorVue from '@/components/editor-vue.vue'
export default {
  components: { EditorVue },
  data() {
    return {
      loading: false,
      form: {
        title: '',
        content: ''
      },
      formRule: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        content: [{ required: true, message: '请输入内容', trigger: 'blur' }]
      }
    }
  },
  computed: {
    project_id() { return this.$store.state.project.projectId }
  },
  created() { },
  mounted() { },
  methods: {
    // 发布
    release() {
      this.$refs['formRef'].validate((valid) => {
        if (valid) {
          const { title, content } = this.form
          this.loading = true
          this.$api.project
            .createissue({
              title,
              content,
              project_id: this.project_id
            })
            .then((res) => {
              const { message } = res
              if (message === 'Success') {
                this.$message.success('发布成功')
                this.$emit('fresh')
              }
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    // 取消
    cancel() {
      this.$emit('cancel')
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
